'use strict'

require('./polyfills')
var PrimaryNav = require('./components/PrimaryNav')
var PrimaryNavToggler = require('./components/PrimaryNavToggler')
var HeadSlider = require('./components/HeadSlider')
var Modal = require('./components/Modal')
var BemCarousel = require('./components/BemCarousel')
var validate = require('./helpers/validate')

// --------------- HELPERS -------------

function formatServerError(jqXHR) {
	if (jqXHR.responseText.length)
		return 'Server error: ' + jqXHR.responseText
	return jqXHR.status + ' error'
}

// ---------------- APP ----------------

var App = function(config) {
	config = config || {}
	this.config = Object.assign({}, App.DEFAULTS, config)
}

App.DEFAULTS = {
	headSlider: {
		// Sliding animation duration (in milliseconds)
		slideDuration: 200,
		autoSlide: true,
		// Waiting time until next auto slide (in milliseconds)
		autoSlideWait: 3000,
		stopAutoSlideOnHover: true
	}
}

Object.assign(App.prototype, {
	init: function() {
		this.initPrimaryNav()
		this.initHeadSlider()
		this.initFooter()
		this.initCallbackModal()
		this.initSideSubscriptionForm()
		this.initOfferCarousel()
	},
	initPrimaryNav: function() {
		$('.primary-nav').each(function() {
			new PrimaryNav(this).init()
		})
		$('.primary-nav-toggler').each(function() {
			new PrimaryNavToggler(this).init()
		})

		var $headerToggler = $('.header__toggler')
		var toggler = $('#head-primary-nav-toggler').data('PrimaryNavToggler')
		var nav = $('#head-primary-nav').data('PrimaryNav')

		$headerToggler.toggleClass('hidden', nav.inFullMode())

		nav.$el.on(PrimaryNav.EVENT_MODIFIER_CHANGED, function(event, eventData) {
			if (eventData.modifier == 'full') {
				$headerToggler.toggleClass('hidden', eventData.full)
			}
		})

		toggler.$el.on(PrimaryNavToggler.EVENT_TOGGLE, function() {
			nav.toggleMenu(toggler.isOpen(), {silent: true})
		})
		nav.$el.on(PrimaryNav.EVENT_MENU_TOGGLE, function() {
			toggler.toggle(nav.isMenuOpen(), {silent: true})
		})
	},
	initHeadSlider: function() {
		var self = this
		$('.head-slider').each(function() {
			new HeadSlider(this, self.config.headSlider).init()
		})
	},
	initFooter: function() {
		var $hint = $('.footer__hint')
		var $btn = $('.footer__callback')
		$btn.hover(function() {
			$hint.addClass('open')
		}, function() {
			$hint.removeClass('open')
		})
	},
	initCallbackModal: function() {
		var $modal = $('#callback-modal')
		var $form = $('form', $modal)
		var modal = this.callbackModal = new Modal($modal)

		$('.footer__callback').on('click', function() {
			modal.show()
		})
		$('.price-callback__callback .button').on('click', function() {
			modal.show()
		})

		$modal.on('show.modal', function(e) {
			var $form = $('form', e.currentTarget)
			cleanFormError($form)
			cleanAllFormGroupErrors($form)
			$form.get(0).reset()
		})

		$form.on('submit', function(e) {
			e.preventDefault()

			var $form = $(e.currentTarget)
			cleanFormError($form)

			if (validate($form)) {
				var $submit = $form.find('[type=submit]')
					.attr('disabled', 'disabled')
				var url = $form.attr('action')
				$.post(url, $form.serialize())
					.then(function(data) {
						// TODO: some behaviour
						cleanAllFormGroupErrors($form)
						window.location.href = "about:blank"
					}, function(jqXHR, textStatus, errorThrown) {
						putFormError($form, formatServerError(jqXHR))
					})
					.always(function() {
						$submit.removeAttr('disabled')
					})
			}
		})

		function validate(form) {
			var $form = $(form)
			var $name = $('[name="name"]', form)
			var $phone = $('[name="phone"]', form)
			var $email = $('[name="email"]', form)

			var name = $name.val()
			var phone = $phone.val()
			var email = $email.val()

			var errorCount = 0

			if (!name.length) {
				putFormGroupError($name, 'Пожалуйста, укажите имя')
				++errorCount
			} else {
				cleanFormGroupError($name)
			}
			
			if (!phone.length) {
				putFormGroupError($phone, 'Заполните номер телефона')
				++errorCount
			} else if (!validate.phone(phone)) {
				putFormGroupError($phone, 'Номер введен некорректно')
				++errorCount
			} else {
				cleanFormGroupError($phone)
			}

			if (email.length && !validate.email(email)) {
				putFormGroupError($email, 'Некорректный адрес email')
				++errorCount
			} else {
				cleanFormGroupError($email)
			}

			return !errorCount
		}
		function putFormGroupError($el, message) {
			$el.closest('.form-group')
				.addClass('has-error')
				.find('.form-group__error')
					.text(message)
		}
		function cleanFormGroupError($el) {
			$el.closest('.form-group')
				.removeClass('has-error')
				.find('.form-group__error')
					.empty()
		}
		
		function cleanAllFormGroupErrors(form) {
			var $form = $(form)
			cleanFormGroupError($('[name="name"]', form))
			cleanFormGroupError($('[name="phone"]', form))
			cleanFormGroupError($('[name="email"]', form))
		}
		function putFormError(form, message) {
			$('.form-error', form).removeClass('hidden').text(message)
		}
		function cleanFormError(form) {
			$('.form-error', form).addClass('hidden').empty()
		}
	},
	initSideSubscriptionForm: function() {
		$('.side-subscription').each(function() {
			var FORM_GROUP_SELECTOR = '.side-subscription__form-group'
			var FORM_ERROR_SELECTOR = '.side-subscription__form-error'
			var HAS_ERROR_CLASS = 'has-error'

			var $form = $(this)
			var $error = $(FORM_ERROR_SELECTOR, this)
			var $email = $('[name="email"]', this)

			$form.on('submit', function(e) {
				e.preventDefault()

				var email = $email.val()
				if (!email.length) {
					putFormGroupError($email, 'Введите E-mail')
				} else if(!validate.email(email)) {
					putFormGroupError($email, 'Некорректный E-mail')
				} else {
					var $submit = $form.find('[type=submit]')
						.attr('disabled', 'disabled')
					var url = $form.attr('action')
					$.post(url, $form.serialize())
						.then(function(data) {
							// TODO: some behaviour
							cleanFormGroupError($email)
							window.location.href = "about:blank"
						}, function(jqXHR, textStatus, errorThrown) {
							putFormGroupError($email, formatServerError(jqXHR))
						})
						.always(function() {
							$submit.removeAttr('disabled')
						})
				}
			})

			function putFormGroupError($el, message) {
				$el.closest(FORM_GROUP_SELECTOR)
					.addClass(HAS_ERROR_CLASS)
					.find(FORM_ERROR_SELECTOR)
						.text(message)
			}
			function cleanFormGroupError($el) {
				$el.closest(FORM_GROUP_SELECTOR)
					.removeClass(HAS_ERROR_CLASS)
					.find(FORM_ERROR_SELECTOR)
						.empty()
			}
		})
	},
	initOfferCarousel: function() {
		var $offerCardList = $('#offer-cards')
		var $offerCarousel = $('#offer-carousel')

		if ($offerCardList.length) {
			var cardCarousel = new BemCarousel({
				el: $offerCardList.get(0),
				block: 'offer-card-list',
				slider: 'tape',
				elements: {
					slide: 'offer-card',
					next: '__right',
					prev: '__left'
				},
				modifiers: {
					current: 'active',
					hasNext: 'has-right',
					hasPrev: 'has-left'
				},
				autoSlide: false,
				currentSlideCentering: true,
				clickablePrevNext: false,
				cyclicScrolling: false,
				stripfilm: true
			})
			cardCarousel.init()
		}

		if ($offerCarousel.length) {
			var offerCarousel = new BemCarousel({
				el: $offerCarousel.get(0),
				block: 'offer-carousel',
				slider: 'tape',
				autoSlide: false
			})
			offerCarousel.init()

			// modal activation buttons
			var self = this
			offerCarousel.$el.on('click', '.offer-carousel__button[data-toggle="modal"][data-target="#callback-modal"]', function() {
				self.callbackModal.show()
			})
		}

		if ($offerCardList.length && $offerCarousel.length) {
			// Sliding activate card
			offerCarousel.$el.on('slide.bem-carousel', function(e, index) {
				cardCarousel.slideTo(index)
			})
			// Clicking on card slides carousel
			var $cards = $('.offer-card', $offerCardList)
			$cards.click(function() {
				offerCarousel.slideTo($cards.index(this))
			})
		}
	}
})

module.exports = App



/*****************
 ** WEBPACK FOOTER
 ** ./app.js
 ** module id = 0
 ** module chunks = 0
 **/